import { Box, ListItemButton, ListItemText, Typography, Divider, useTheme } from '@mui/material';
import dayjs from 'dayjs';

import { useNoteListItem } from './useNoteListItem';
import type { Note } from '../../../types/response';

interface NoteListItemProps {
  note: Note;
}

export const NoteListItem = ({ note }: NoteListItemProps) => {
  const theme = useTheme();
  const { selectNote, selectedNoteId } = useNoteListItem();
  return (
    <Box key={note.noteId}>
      <ListItemButton
        selected={selectedNoteId === note.noteId}
        onClick={() => selectNote(note.noteId)}
        sx={(theme) => ({
          alignItems: 'flex-start',
          py: 1.5,
          borderLeft: '3px solid transparent', // reserve space always

          '&.Mui-selected': {
            borderLeft: `3px solid ${theme.palette.primary.main}`,
            backgroundColor: theme.palette.action.selected,
          },

          '&.Mui-selected:hover': {
            backgroundColor: theme.palette.action.selected,
          },
        })}
      >
        <ListItemText
          primary={
            <Box>
              <Typography
                variant="body2"
                fontWeight={500}
                sx={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {dayjs(note.noteDatetime).format('MM/DD/YYYY | HH:mm')} - {note.noteType}
              </Typography>
            </Box>
          }
          secondary={
            <Typography
              variant="caption"
              color={theme.palette.text.secondary}
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {note.noteClass} - {note.noteText.length.toLocaleString()} chars
            </Typography>
          }
        />
      </ListItemButton>
      <Divider />
    </Box>
  );
};
